module.exports = __webpack_public_path__ + "static/media/how4.3cdfba61.svg";